module.exports = ""


//////////////////
// WEBPACK FOOTER
// /app/src/app/wb/geometry/geometry-tools.component.html
// module id = ../../../../../src/app/wb/geometry/geometry-tools.component.html
// module chunks = main